import { useState } from "react";

import { AcquirerEditForm } from "src/app/features/Acquirer/components/forms/AcquirerEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const AcquirerEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.ACQUIRER, "basicTabsWrite");

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.acquirersPhysicalEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.ACQUIRER}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <AcquirerEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
